import React , {useState} from "react";
import styles from "./Support.module.scss";
import InfoTopBar from "../common/InfoTopBar/InfoTopBar";
import cardData from "./cardData"

const Support = () => {

    const [card , setCardData] = useState(cardData);

  return (
    <div className={styles.container}>
      <div style={{ padding: "10px 25px" }}>
        <InfoTopBar
          heading="Support"
          info={false}
          divider={true}
        >
        </InfoTopBar>
      </div>

      <div className={styles.wrapper}>
      <div className={styles.img}>
      <img src="/assets/hogipay.png" alt="hogi-pay"/>
      </div>
      </div>

      <div className={styles.text}>
      Use the option below to learn about Hogi Pay <br/>
       solve problems and get in touch.
      </div>
      <div className={styles.text2}>       
      Thank you for using Hogi Pay.
     </div>

     <div className={styles.cardwrapper}>
     {

        card.map((currData) =>{
            const {id,img,heading,para} = currData;
            return(
                <div className={styles.card}>
                <img src={img} alt="chat"/>
                <div className={styles.heading}>{heading}</div>
                <div className={styles.para}>{para}</div>
                </div> 
            )
        })
     }
     </div>
    </div>
  );
};

export default Support;
